import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=62da5779&scoped=true&"
import script from "./TreeItem.vue?vue&type=script&lang=ts&"
export * from "./TreeItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62da5779",
  null
  
)

export default component.exports